<template>
  <div id="app" class="mainCon" :style="nosubmenu.indexOf($route.path)>-1?'overflow:unset':''">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
import Cookie from 'js-cookie'

export default {
  data() {
    return {
      username: '',
      nosubmenu:['/web/staticImg/achievements','/web/staticImg/countryExbition','/web/staticImg/nationalExbition','/web/staticImg/theme','/web/staticImg/environment']
    }
  },
  watch: {
    $route(to) {
      //路由变化关闭加载中动画
      this.$toast.clear()
      document.title = to.meta.title
      this.joyaLoad()
    }
  },
  methods: {
    joyaLoad() {
      let _userName = Cookie.get('ss_user_name')
      let _account = Cookie.get('ss_account_name')
      if (_userName) {
        //      if (_userName) window.jaq.push(['erp_account', _userName])
        let _account_val = _userName + (_account ? '@' + _account : '')
        if (window._isMobile) window.jap.account = _account_val
        else window.jaq.push(['erp_account', _account_val])
      }
      try {
        ;(() => {
          let _oldScript = document.getElementById('joya')
          if (_oldScript) _oldScript.remove()
          var ja = document.createElement('script')
          ja.type = 'text/javascript'
          ja.id = 'joya'
          ja.async = true
          ja.src = window._isMobile
            ? '//wl.jd.com/unify.min.js'
            : '//wl.jd.com/joya.js'
          var s = document.getElementsByTagName('script')[0]
          s.parentNode.insertBefore(ja, s)
        })()
      } catch (_err) {
        console.log(_err)
      }
    }
  },
  created() {
    console.log(this.$route)
    this.joyaLoad()
  },
  mounted() {
    this.$base.focusout() //键盘事件优化
  }
}
</script>
<style>
.mainCon {
  width: 100%;
  overflow: hidden;
}
.page-fixed {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  background: #f5f5f5;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
</style>
